module.exports = __webpack_public_path__ + "static/media/assess.4d42e435.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/assess.jpg
// module id = 2851
// module chunks = 0